import React from 'react';
import { Button } from 'appkit-react';

const EditButton = (props) => {
  const {
    isEditing = false,
    isLoading = false,
    toggleEdit,
    onCancel,
    saveEdit,
  } = props;

  const wrapperClassName = 'edit-btn-wrapper';

  if (isEditing) {
    return (
      <div className={wrapperClassName}>
        {!isLoading && (
          <Button
            size="lg"
            kind="secondary"
            onClick={() => {
              toggleEdit();
              onCancel();
            }}
          >
            cancel
          </Button>
        )}
        <Button
          size="lg"
          kind="primary"
          onClick={() => {
            saveEdit();
          }}
          isLoading={isLoading}
        >
          save
        </Button>
      </div>
    );
  }
  return (
    <div className={wrapperClassName}>
      <Button size="lg" kind="primary" onClick={toggleEdit}>
        edit
      </Button>
    </div>
  );
};

export default EditButton;
